import { articleImages } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import enArticles from "@/i18n/local/en/articles";

export interface SeoMeta {
  title: string;
  description: string;
  keywords: string;
  image?: string;
  canonicalPath: string;
  ogType: "website" | "article";
}

interface ArticleSeoSource {
  category: string;
  title: string;
  subtitle: string;
}

const articleMap = enArticles.articles as unknown as Record<string, ArticleSeoSource>;

const HOME_OG_IMAGE = categories[0]?.image ?? "";

export const HOME_SEO: SeoMeta = {
  title: "AllChinaBuy Spreadsheet: Finds, Guides, Reviews & Shipping",
  description:
    "Explore the AllChinaBuy Spreadsheet with product finds, seller guides, QC tips, shipping information, reviews, coupons and practical buying resources in one place.",
  keywords:
    "AllChinaBuy Spreadsheet, AllChinaBuy spreadsheet 2026, AllChinaBuy spreadsheet finds, AllChinaBuy spreadsheet products, AllChinaBuy review, AllChinaBuy shipping cost, AllChinaBuy guide",
  image: HOME_OG_IMAGE,
  canonicalPath: "/",
  ogType: "website",
};

export function getArticleSeo(slug: string): SeoMeta | undefined {
  const source = articleMap[slug];
  if (!source) return undefined;
  return {
    title: source.title,
    description: source.subtitle,
    keywords: `${source.category}, AllChinaBuy Spreadsheet, AllChinaBuy spreadsheet guide, AllChinaBuy spreadsheet finds, AllChinaBuy review`,
    image: articleImages[slug],
    canonicalPath: `/guide/${slug}`,
    ogType: "article",
  };
}